import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Styles
import styles from './IconButton.module.scss';

const cx = classNames.bind(styles);

const IconButton = props => {
  const { className, onClick, dataCy, dataTest, children, ...rest } = props;

  const closeClassName = cx('icon-button', className);

  return (
    <button
      type="button"
      onClick={props.onClick}
      className={closeClassName}
      data-cy={dataCy}
      data-test={dataTest}
      {...rest}
    >
      {children}
    </button>
  );
};

IconButton.defaultProps = {
  className: '',
  dataCy: '',
  dataTest: '',
  onClick: () => {},
  size: 'small'
};

IconButton.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  dataCy: PropTypes.string,
  dataTest: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['normal', 'small', 'extra_small'])
};

export default IconButton;
